import React from 'react';
import MenuMain from '../../MenuMain';
import { FormRomaneio } from '../../components/FormRomaneio';
import { AppFooter } from '../../AppFooter';


export default function CadastrarRomaneioPage(props) {

  const romaneioItens = {
		"id": 0,
		"quantidade": 0.0,
		"romaneioId": 0,
		"produtoId": 0,
		"produtoNome": ""
	}

  const dados = props.location.dados

  return (
    <div>
      <MenuMain>
         <FormRomaneio
          romaneioItens={romaneioItens  }
          dados = {dados}
          
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

